import styled from "styled-components";

export const Section = styled.section`
  background: #131416;
  padding: 3rem 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const Container = styled.div`
padding: 0 7rem 0 7rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    margin-bottom: 30px;
    cursor: pointer;
  }
  @media only screen and (max-width: 1400px) {
    width: 63%;
  }
  @media only screen and (min-width: 1401px) {
    width: 53.5%;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  svg {
    margin: 10px;
  }
`;

export const LinkContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  span {
    color: #fff;
    cursor: pointer;
    padding: 15px;
    &: hover {
      color: #e70289;
    }
  }
`;

export const PartnershipContainer = styled.div`
  display: flex;
  align-items: flex-end;
  img {
    width: 200px;
    height: 100px;
  }
`

export const ClickableIcon = styled.a`
  display: inline-block;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
`